module.exports = __webpack_public_path__ + "static/media/castel.9c5a6261.jpg";